import { render, staticRenderFns } from "./ParallelRatingScreenExample.vue?vue&type=template&id=726d37e3"
import script from "./ParallelRatingScreenExample.vue?vue&type=script&lang=js"
export * from "./ParallelRatingScreenExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports